export default __webpack_public_path__ + "static/media/cardimgfree.700a968e.png";